// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from '../ReactCSSTransitionGroupCompat/ReactCSSTransitionGroupCompat';
// Components
import OMTooltip from '../OMComponents/OMTooltip/OMTooltip';
import VerificationCodeSection from './Sections/VerificationCodeSection';
import PhoneNumberSection from './Sections/PhoneNumberSection';
// Styles
import * as styles from './PhoneVerificationForm.scss';
import icon from '../../../static/icons/help-button.png';

class PhoneVerificationForm extends Component {
  state = {
    showTooltip: false
  };

  tooltipHandler = () => {
    this.setState({ showTooltip: !this.state.showTooltip });
  };

  render() {
    const phoneNumberSection = (
      <PhoneNumberSection
        translate={this.props.translate}
        locale={this.props.locale}
        onChange={this.props.onChange}
        validatePhoneNumber={this.props.validatePhoneNumber}
        sendPhoneNumber={this.props.sendPhoneNumber}
        fetchReCaptchaToken={this.props.fetchReCaptchaToken}
        phoneForCaptcha={this.props.phoneForCaptcha}
        phoneNumberIsInvalid={this.props.phoneNumberIsInvalid}
        phoneNumberSent={this.props.phoneNumberSent}
        showPhonePreloader={this.props.showPhonePreloader}
        isMobile={this.props.isMobile}
        errorMessage={this.props.errorMessage}
        showErrorMessage={this.props.showErrorMessage}
        doResetCaptcha={this.props.doResetCaptcha}
        phoneNumberAlreadyTaken={this.props.phoneNumberAlreadyTaken}
        isRtl={this.props.isRtl}
      />
    );

    const codeSection = (this.props.phoneNumberSent)
      ? (<VerificationCodeSection
        translate={this.props.translate}
        onChange={this.props.onChange}
        validateCode={this.props.validateCode}
        codeIsValid={this.props.codeIsValid}
        showCodePreloader={this.props.showCodePreloader}
        codeIsVerified={this.props.codeIsVerified}
        isRtl={this.props.isRtl}
      />)
      : null;

    return (
      <div className={styles.verificationForm}>
        <div className={styles.title}>
          <span>{this.props.translate('phoneVerificationMessage')}</span>
          <div className={styles.tooltipButton}>
            <img
              src={icon}
              alt="help-icon"
              tabIndex={0}
              onClick={this.tooltipHandler}
              onBlur={() => this.setState({ showTooltip: false })}
            />
            { this.state.showTooltip ?
              <OMTooltip
                msg={this.props.tooltipMsg}
                locale={this.props.locale}
                className="phoneVerificationTooltip"
                onClose={this.tooltipHandler}
              /> : null }
          </div>
        </div>
        {phoneNumberSection}
        <ReactCSSTransitionGroup
          transitionName="code-section"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={400}
        >
          {codeSection}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

PhoneVerificationForm.propTypes = {
  translate: PropTypes.func,
  tooltipMsg: PropTypes.string,
  locale: PropTypes.string,
  onChange: PropTypes.func,
  validateCode: PropTypes.func,
  validatePhoneNumber: PropTypes.func,
  sendPhoneNumber: PropTypes.func,
  fetchReCaptchaToken: PropTypes.func,
  phoneForCaptcha: PropTypes.string,
  phoneNumberSent: PropTypes.bool,
  codeIsValid: PropTypes.bool,
  codeIsVerified: PropTypes.bool,
  phoneNumberIsInvalid: PropTypes.bool,
  showCodePreloader: PropTypes.bool,
  showPhonePreloader: PropTypes.bool,
  isMobile: PropTypes.bool,
  showErrorMessage: PropTypes.bool,
  doResetCaptcha: PropTypes.bool,
  errorMessage: PropTypes.string,
  phoneNumberAlreadyTaken: PropTypes.bool,
  isRtl: PropTypes.bool
};

export default PhoneVerificationForm;
